import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { LocationReport } from '../../../interfaces/location-report.interface';

export interface LocationReportState {
    locationsReport: LocationReport[];
    loading: boolean;
    error: string | null;
}

const initialState: LocationReportState = {
    locationsReport: [],
    loading: false,
    error: null,
};

const locationReportSlice = createSlice({
    name: 'locationReport',
    initialState,
    reducers: {
        getLocationReportInitAction: (state) => {
            state.loading = true;
            state.error = null;
        },
        getLocationReportSuccessAction: (state, action: PayloadAction<LocationReport[]>) => {
            state.loading = false;
            state.locationsReport = action.payload;
            state.error = null;
        },
        getLocationReportFailureAction: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
        clearLocationReportAction: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const {
    getLocationReportInitAction,
    getLocationReportSuccessAction,
    getLocationReportFailureAction,
    clearLocationReportAction,
} = locationReportSlice.actions;

export default locationReportSlice.reducer; 